<div class="container">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>Follow Ups List</h2>
  </div>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex gap-2 mb-3">
      <div class="form-floating">
        <select id="dueFilterSelect" class="form-select" [(ngModel)]="selectedDueFilter" (change)="applyFilters()">
          <option value="" disabled selected hidden></option>
          <option value="all">ALL</option>
          <option value="today">Due Today</option>
          <option value="tomorrow">Due Tomorrow</option>
          <option value="nextWeek">Next Week</option>
        </select>
        <label for="dueFilterSelect">Due</label>
      </div>
    </div>
  </div>
  <div class="custom-table-wrapper">
    <table class="table table-bordered custom-table">
      <thead>
        <tr>
          <th>Quote #</th>
          <th>Client Name</th>
          <th>Assigned To</th>
          <th>Follow-up Date</th>
          <th>Next Follow-up Date</th>
          <th>Actions</th>
        </tr>
        <tr>
          <th>
            <input type="text" class="form-control form-control-sm" placeholder="Search Quote #"
              [(ngModel)]="filter.quoteId" (input)="applyFilters()" />
          </th>
          <th>
            <input type="text" class="form-control form-control-sm" placeholder="Search Client"
              [(ngModel)]="filter.clientName" (input)="applyFilters()" />
          </th>
          <th>
            <input type="text" class="form-control form-control-sm" placeholder="Search Assigned To"
              [(ngModel)]="filter.assignedTo" (input)="applyFilters()" />
          </th>
          <th>
            <input type="text" class="form-control form-control-sm" placeholder="dd/mm/yyyy"
              [(ngModel)]="filter.followUpDate" (input)="applyFilters()" />
          </th>
          <th>
            <input type="text" class="form-control form-control-sm" placeholder="dd/mm/yyyy"
              [(ngModel)]="filter.nextFollowUpDate" (input)="applyFilters()" />
          </th>
          <th>
            <button (click)="resetFilters()" class="btn btn-sm text-primary">
              <i class="fa fa-x" aria-hidden="true"></i>
            </button>
          </th>
        </tr>

      </thead>
      <tbody>
        <tr *ngFor="let fup of filteredFollowUpsList">
          <td>{{ (fup.quotationId) }}</td>
          <td>{{ getClientName(fup.quotationId) }}</td>
          <td>{{ getAssignedToName(fup.quotationId) }}</td>
          <td>{{ fup.followUpDate | date:'dd/MM/yyyy' }}</td>
          <td>{{ fup.nextFollowUpDate | date:'dd/MM/yyyy' }}</td>
          <td>
            <button (click)="viewFollowUp(fup.quotationId)" class="btn btn-primary btn-sm">
              <i class="fa fa-eye" aria-hidden="true"></i>
            </button>
            <button (click)="deleteFollowUp(fup)" class="btn btn-danger btn-sm">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>